const StatusTypes = {
	current	:	'current',
	disabled:	'disabled',
	complete:	'complete'
};

export {
	StatusTypes
}